"use client";

import React from "react";
import {MeetingProvider} from "amazon-chime-sdk-component-library-react";

export const ClientMeetingProvider = ({ children } : { children: React.ReactNode }) => {
    return (
        <MeetingProvider>
            {children}
        </MeetingProvider>
    );
}